// extracted by mini-css-extract-plugin
module.exports = {"Title":"Column_Title__FO9vT","Column":"Column_Column__3_XCR","Links":"Column_Links__2c3VZ"};